/**
 * Typed cache keys for the dashboard feature.
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 * Per the `useCount` query-key naming fix (commit fd3f09e on main, May 8):
 * the count keys carry a `-count` suffix to avoid collisions with future
 * non-count queries on the same resource (e.g. `dashboard.employees.list`).
 */
export const dashboardKeys = {
	all: ['dashboard'] as const,
	statsMy: () => [...dashboardKeys.all, 'stats', 'my'] as const,
	openRequests: () => [...dashboardKeys.all, 'open-requests'] as const,
	recentActivity: () => [...dashboardKeys.all, 'recent-activity'] as const,
	closedLast30d: () => [...dashboardKeys.all, 'closed-last-30d'] as const,
	requestTypesCatalog: () => [...dashboardKeys.all, 'request-types-catalog'] as const,
	pendingApprovals: () => [...dashboardKeys.all, 'pending-approvals'] as const,
	adminStats: () => [...dashboardKeys.all, 'admin-stats'] as const,
	pendingIdmConfirmations: () => [...dashboardKeys.all, 'pending-idm-confirmations'] as const,
	count: (resource: string) => [...dashboardKeys.all, 'count', resource] as const,
}
